import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import useGradesTableStore from '../store/useGradesTableStore';

const useAssignments = () => {
  const stafferId = useGradesTableStore(state => state.stafferId);
  const programId = useGradesTableStore(state => state.programId);
  const lesson = useGradesTableStore(state => state.lesson);
  const unit = useGradesTableStore(state => state.unit);
  const classroom = useGradesTableStore(state => state.classroom);
  const setStore = useGradesTableStore(state => state.setStore);

  const query = useQuery(['Assignment', stafferId], () => {
    const searchParams = {
      extra_attributes: ['assignment_details'],
      for_classroom: classroom.id,
      in_program: programId,
    };

    if (lesson) {
      searchParams['in_lesson'] = lesson.id;
    } else {
      searchParams['in_unit'] = unit.id;
    }

    return axios.get(Routes.plato_api_staffer_assignments_path(stafferId, searchParams))
      .then(res => res.data.data);
  });

  useEffect(() => {
    if (query.isFetching || !query.data) return;

    setStore({ assignments: query.data });
  }, [query.data]);

  return query;
};

export default useAssignments;
